import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { handleLogoutAction } from 'utils/LoginUtils/smartLoginHelper';
import { removeObject } from 'utils/localStorage';
import { chatCredentialsLocalStorageKey } from 'utils/chatUtils';
export var logout;
(function (logout) {
    logout["LOGOUT_REQUEST"] = "LOGOUT_REQUEST";
    logout["LOGOUT_SUCCESS"] = "LOGOUT_SUCCESS";
    logout["LOGOUT_ERROR"] = "LOGOUT_ERROR";
})(logout || (logout = {}));
export function logoutSuccessAction(data, silently, targetUrl) {
    if (!silently && ExecutionEnvironment.canUseDOM) {
        window.location.href = targetUrl || '/';
    }
    removeObject(chatCredentialsLocalStorageKey);
    handleLogoutAction(); // to preventSilentAccess from GoogleSmartLock
    return { type: logout.LOGOUT_SUCCESS, data };
}
export function logoutAction(silently, targetUrl) {
    return (dispatch) => {
        dispatch({
            type: logout.LOGOUT_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/2/user/logout',
            acceptErrors: true,
            action: logout.LOGOUT_REQUEST
        }), `${new Date().getTime()}`).then(data => {
            dispatch(logoutSuccessAction(data, silently, targetUrl));
            return Promise.resolve(data);
        }, err => {
            if (err.STATUS_CODE === 401) {
                window.location.href = '/';
            }
            dispatch({
                type: logout.LOGOUT_ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
